import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapArrayHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Array;
    }
}

//# sourceMappingURL=WrapArrayHelper.js.map
